import type { AspectRatio } from "../types/roast";

const DIMS: Record<AspectRatio, { w: number; h: number }> = {
  "16:9": { w: 16, h: 9 },
  "9:16": { w: 9, h: 16 },
};

/** Inline style for the player stage: the largest aspect-correct box that fits
 *  its (container-query) container. The outer container must set
 *  `container-type: size`. Width picks the width- or height-limited fit; the
 *  aspect-ratio derives the height.
 *
 *  `fontSize` sets the caption BASE (the caption `em` sizing keys off it, and the
 *  video export reads it via getComputedStyle). It scales with the stage — `cqh` is
 *  relative to the size-container height — so captions stay proportional in a small
 *  preview, but is clamped at the 16px design base so a full-size player looks exactly
 *  as before. Below ~533px of stage height (e.g. StudioCreate's half-width 16:9 preview)
 *  it scales down. The caption renderer applies its per-aspect ×1.32 on top. */
export function stageStyle(aspect: AspectRatio): { aspectRatio: string; width: string; fontSize: string } {
  const { w, h } = DIMS[aspect];
  return {
    aspectRatio: `${w} / ${h}`,
    width: `min(100cqw, calc(100cqh * ${w} / ${h}))`,
    fontSize: "min(16px, 3cqh)",
  };
}
